import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=f647ac96&"
import script from "./DefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports